export default __webpack_public_path__ + "images/IB.9cbd3da.png";